export default "__VITE_ASSET__98ac77d8__"